"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var o = require('styled-components');
var reactAvatar = require('@radix-ui/react-avatar');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var o__default = /*#__PURE__*/_interopDefaultLegacy(o);

var c={default:{bg:"--background-default-base",border:"--border-default"},blurple:{bg:"--background-brand-base",border:"--border-brand"},blue:{bg:"--background-info-base",border:"--border-info"},green:{bg:"--background-success-base",border:"--border-success"},yellow:{bg:"--background-warning-base",border:"--border-warning"},pink:{bg:"--background-error-base",border:"--border-error"}},p={small:"24px",regular:"32px",large:"48px",xlarge:"64px"},u={circle:"100%",square:"4px"},l=o__default["default"](reactAvatar.Fallback)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  color: var(--foreground-primary);
`,v=o__default["default"](reactAvatar.Root)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
  user-select: none;
  width: ${({$size:r})=>p[r]};
  height: ${({$size:r})=>p[r]};
  border-radius: ${({$shape:r})=>u[r]};

  ${({$color:r})=>o.css`
    border: 1px solid var(${c[r].border});

    ${l} {
      background-color: var(${c[r].bg});
    }
  `};
`,d=o__default["default"](reactAvatar.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;o__default["default"].div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;function y({shape:r}){return jsxRuntime.jsx("svg",{width:"64",height:"64",viewBox:"-16 -15 64 64",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:r==="circle"?jsxRuntime.jsx("path",{d:"M16 16a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3 3h-6C7 19 2 24 2 30l2 2h24l2-2c0-6-5-11-11-11Z",fill:"var(--foreground-tertiary)"}):jsxRuntime.jsx("path",{d:"m21 19 1-1h2l1 1v2l-1 1h-2l-1-1v-2Zm0-12 1-1h2l1 1v2l-1 1h-2l-1-1V7Zm1 9-1-1v-2l1-1h2l1 1v2l-1 1h-2Zm6-16c2 0 4 2 4 4v24c0 2-2 4-4 4H18c-2 0-4-2-4-4V4c0-2 2-4 4-4h10Zm0 3H18l-1 1v24l1 1h10l1-1V4l-1-1Zm-16 8H5l-2 2v15l2 1h7l2 3H5c-3 0-5-2-5-4V13c0-3 2-5 5-5h7v3Zm-3 9 1 1v2l-1 1H7l-1-1v-2l1-1h2Zm0-6 1 1v2l-1 1H7l-1-1v-2l1-1h2Z",fill:"var(--foreground-tertiary)"})})}var g=y;function k(r){let a=r.trim().split(" ");if(a.length===0)return "";if(a.length===1)return a[0].charAt(0).toUpperCase();let e=a[0].charAt(0),t=a[a.length-1].charAt(0);return `${e}${t}`.toUpperCase()}function w({fullName:r,url:a,delayMs:e,size:t="regular",color:b="default",shape:n="circle"}){return jsxRuntime.jsxs(v,{$size:t,$shape:n,$color:b,children:[jsxRuntime.jsx(d,{src:a,alt:r}),jsxRuntime.jsx(l,{delayMs:e,$size:t,title:r||"avatar icon",children:r?k(r):jsxRuntime.jsx(g,{shape:n})})]})}var S=o__default["default"](w)``;

exports.a = S;
